import React from "react";
import { withRouter } from "react-router-dom";
import { useQuery } from "react-apollo-hooks";
import { STORE_DELIVERY_PRODUCT_CATEGORY_LIST_QUERY } from "../../Queries";
import Presenter from "./Presenter";

export default withRouter(({ history, match, location }) => {
  const baseUrl = "/delivery/deliveryProducts/categories";

  const { data, loading, error } = useQuery(
    STORE_DELIVERY_PRODUCT_CATEGORY_LIST_QUERY,
    {
      fetchPolicy: "network-only",
      variables: { take: 100, skip: 0 },
    }
  );

  if (loading) {
    return <></>;
  }
  if (error) {
    return <>{error.message}</>;
  }

  return (
    <Presenter
      history={history}
      match={match}
      location={location}
      loading={loading}
      data={data}
      baseUrl={baseUrl}
    />
  );
});
